import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import RecipientsSection from './RecipientsSection';
import SubjectSection from './SubjectSection';
import BodySection from './BodySection';
import AttachmentSection from './AttachmentSection';
import TestEmailSection from './SendTestEmailSection';

const SendCommunicationModalBody: FC = () => (
  <Modal.Body className="send-communication-modal__body">
    <RecipientsSection />
    <SubjectSection />
    <BodySection />
    <AttachmentSection />
    <TestEmailSection />
  </Modal.Body>
);

export default SendCommunicationModalBody;
